import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import Layout from '../../components/Layout';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';

import validators from '../../helpers/validators';
import useCases from '../../useCases';
import paths from '../../routes/paths';
import { Container, Content, Paragraph, Span, HelperImage } from './styles';
import { Images } from '../../themes';

export default function Permissions({ lead }) {
  const history = useHistory();
  const location = useLocation();
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    (async () => {
      const params = qs.parse(location.search);
      if (params && params.code && !validators.email(params.state)) {
        setFetching(true);
        const result = await useCases.savePermissions(params);
        setFetching && setFetching(false);

        if (result.success) {
          history.push({
            pathname: paths.install,
            search: '',
          });
        } else if (result.returnToActivate) {
          history.push({
            pathname: paths.activate,
            search: '',
          });
        } else if (result.returnToAlreadyExists) {
          history.push({
            pathname: paths.alreadyExists,
            search: '',
          });
        }
      }
    })();
  }, []);

  const grantPermissions = () => {
    useCases.grantPermissions(lead.email);
  };

  return (
    <Layout activeRoute="activate" mapImageOnBackground={false}>
      <Container>
        <HelperImage src={Images.permission} />
        <Content>
          <Title>
            Almost <highlight>there!</highlight>
          </Title>
          <Subtitle text="We need your permission for our App in your Microsoft account" />
          <Paragraph>
            You will need to click in the &quot;Go to Microsoft&quot; button
            bellow read all the content to consent and accept the permissions
            requested, if you are not logged in the Microsoft account you will
            need to login.
          </Paragraph>
          <Paragraph>
            Click in Accept at the end of the content to make InStation an app
            shared to all your company this is needed to make the app work!
          </Paragraph>
          {fetching ? (
            <Spinner size={{ height: 80 }} />
          ) : (
            <>
              <Button
                onClick={grantPermissions}
                icon={Images.icons.microsoft}
                alt="Microsoft icon"
                text="Go to Microsoft"
              />
              <Span>
                You will automatically return here after accept the permission
                request
              </Span>
            </>
          )}
        </Content>
      </Container>
    </Layout>
  );
}

Permissions.propTypes = {
  lead: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
  }),
};
